import {
  KybDocument,
  KybDocumentStatus,
  KybDocumentType,
} from '__generated__/GQL';

const getDraftStatutesDocument = <
  KybDoc extends Pick<KybDocument, 'type' | 'status'>,
>(company: {
  kybDocuments: KybDoc[];
}) =>
  company.kybDocuments.find(
    (document) =>
      document.type === KybDocumentType.DraftStatutes &&
      document.status !== KybDocumentStatus.Missing,
  );

export default getDraftStatutesDocument;
